import { render, staticRenderFns } from "./default.vue?vue&type=template&id=6355c941"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Promotion: require('/codebuild/output/src3458403893/src/acredo-website/components/promotion/Promotion.vue').default,Header: require('/codebuild/output/src3458403893/src/acredo-website/components/Header.vue').default,Navigation: require('/codebuild/output/src3458403893/src/acredo-website/components/navigation/Navigation.vue').default,Footer: require('/codebuild/output/src3458403893/src/acredo-website/components/Footer.vue').default})
